/**
 * Extract a column of data filled with the specified constant.
 */
export const Constant = ({ value }) => {
    return (data) => data.map(() => value);
};
Constant.props = {};
//# sourceMappingURL=constant.js.map